@if (variant() === 'desktop') {
<button
  #triggerButton
  type="button"
  [attr.aria-label]="title"
  [attr.title]="title"
  [attr.aria-expanded]="isOpen()"
  (click)="toggle()"
  class="tw-relative tw-flex tw-justify-center tw-items-center tw-w-8 tw-h-8 tw-rounded-full hover:tw-bg-gray-200 tw-transition-colors"
  [ngClass]="isOpen() ? 'tw-bg-gray-200' : 'tw-bg-gray-100'"
>
  <app-queued-jobs-icon [size]="14" [fillClass]="isOpen() ? 'tw-fill-blue-600' : 'tw-fill-gray-500'"></app-queued-jobs-icon>
  <ng-container [ngTemplateOutlet]="badge" [ngTemplateOutletContext]="{ $implicit: 'tw-start-5' }" />
</button>
@if (isOpen()) {
<div
  class="tw-absolute tw-top-full tw-end-0 tw-mt-1 tw-z-50 tw-flex tw-flex-col tw-gap-2 tw-w-[406px] tw-max-h-[calc(100vh-72px)] tw-p-3 tw-bg-white tw-border tw-border-gray-200 tw-rounded-xl tw-shadow-xl"
>
  <h3 class="tw-text-base tw-font-semibold tw-font-inter tw-leading-normal tw-text-gray-900">{{ title }}</h3>
  <app-queued-jobs-panel />
</div>
}
} @else {
<button
  #triggerButton
  type="button"
  [attr.aria-label]="title"
  [attr.aria-expanded]="isOpen()"
  (click)="toggle()"
  class="tw-relative tw-flex tw-justify-center tw-items-center tw-w-9 tw-h-9 tw-p-2 tw-cursor-pointer hover:tw-opacity-80 tw-transition-opacity"
>
  <app-queued-jobs-icon [size]="20"></app-queued-jobs-icon>
  <ng-container [ngTemplateOutlet]="badge" [ngTemplateOutletContext]="{ $implicit: 'tw-start-6' }" />
</button>
@if (isOpen()) {
<div class="tw-fixed tw-inset-0 tw-z-[9998] tw-bg-black tw-bg-opacity-50" (click)="close()"></div>
}
<aside
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="title"
  [attr.inert]="isOpen() ? null : ''"
  class="tw-fixed tw-top-0 tw-start-0 tw-z-[9999] tw-flex tw-flex-col tw-h-dvh tw-w-[332px] tw-max-w-[90vw] tw-bg-white tw-shadow-xl tw-transition-transform tw-duration-300 tw-ease-in-out"
  [ngClass]="isOpen() ? 'tw-translate-x-0' : 'ltr:-tw-translate-x-full rtl:tw-translate-x-full'"
  (transitionend)="onDrawerTransitionEnd($event)"
>
  <header class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-pt-2 tw-pb-3 tw-bg-white tw-shadow">
    <div class="tw-flex tw-items-center tw-gap-2">
      <app-queued-jobs-icon [size]="14" [fillClass]="'tw-fill-gray-700'"></app-queued-jobs-icon>
      <h3 class="tw-text-base tw-font-semibold tw-font-inter tw-leading-normal tw-text-gray-700">{{ title }}</h3>
    </div>
    <button
      #closeButton
      type="button"
      [attr.aria-label]="'Close ' + title"
      (click)="close()"
      class="tw-flex tw-items-center tw-justify-end tw-w-8 tw-h-8"
      [innerHTML]="icons.close | safe"
    ></button>
  </header>
  <div class="tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-p-4">
    @if (isDrawerContentMounted()) {
    <app-queued-jobs-panel />
    }
  </div>
</aside>
}

<ng-template #badge let-positionClass>
  @if (processingCount() > 0) {
  <span
    aria-hidden="true"
    class="tw-absolute -tw-top-2 tw-flex tw-items-center tw-justify-center tw-min-w-5 tw-h-5 tw-px-1 tw-rounded-full tw-bg-red-500 tw-text-xs tw-font-medium tw-font-inter tw-leading-3 tw-text-white"
    [ngClass]="positionClass"
  >
    {{ processingCount() }}
  </span>
  }
</ng-template>
